import { createContext } from 'react';
import type { TableContextType } from './types';

const TableContext = createContext<TableContextType>({} as TableContextType);

export default TableContext;
